














import { Component, Emit, Mixins, Prop } from "vue-property-decorator";
import { IReplaceParameters } from "../../../../../../domain/document";
import { InjectedObjectModel } from "./models";
import { default as InjectedObjectDrawer } from "./InjectedObjectDrawer.vue";

@Component({
  components: {
    InjectedObjectDrawer,
  }
})
export default class InjectedObjectList extends Mixins() {
  @Prop()
  source: InjectedObjectModel[];

  @Prop()
  replaceParameters: IReplaceParameters;

  data() {
    return {
      selectedIndex: -1,
    };
  }
  selectedIndex: number;

  onClicked(i: number) {
    this.selectedIndex = i;
    this.click(i);
  }

  @Emit()
  click(index: number): void {}
}
